"use client"

import { getCookie, setCookie, eraseCookie } from "./cookieUtil";

/*export const setToken = token => localStorage.setItem("token", token);
export const getToken = () =>  localStorage.getItem('token') ? localStorage.getItem('token') : null ;
export const clearToken = () => localStorage.removeItem('token');
export const isAuthenticated = () => localStorage.getItem('token') !== null;*/
export const setToken = (token) => setCookie('token', token, 10);
export const getToken = () =>  getCookie('token');
export const clearToken = () => eraseCookie('token');
export const isAuthenticated = () => getCookie('token') !== null;

